import { render } from "./NoteEditor.vue?vue&type=template&id=c5910500&scoped=true"
import script from "./NoteEditor.vue?vue&type=script&lang=js"
export * from "./NoteEditor.vue?vue&type=script&lang=js"

import "./NoteEditor.vue?vue&type=style&index=0&id=c5910500&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5910500"]])

export default __exports__